const fields = [{ name: 'name', label: 'Name', type: 'text', required: true }];
export default fields;
